export default __webpack_public_path__ + "static/media/undraw_login_re_4vu2.4b8ccb49.svg";